import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import Sidenavbar from '../../Components/Sidenavbar/Sidenavbar';
import UserMenu from '../../Components/UserMenu/UserMenu';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function AdminStatistics(props) {
  const userType = 'admin';


  return (
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row">
      <Sidenavbar userType={userType} />
      <div className="container-fluid px-16">
        <UserMenu userType="admin" />

        {/* Dashboard */}
        <div className="row mt-40">
          <div className="col-12 col-lg-10">
            <div className="card -raspberry">
              <div className="row">
                <div className="col-12">
                  <p className="h2">Solicitudes Recibidas</p>
                  {/* <p className="h3 -r">2024</p> */}
                </div>
              </div>
              <div className="row mt-24">
                <div className="col-12">
                  <div className="card -white ">
                    {/* <Line
                      options={options}
                      data={dataDaily}
                    /> */}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Dashboard */}


      </div>
    </div>
  );
}

export default AdminStatistics;